import { createStore } from "vuex";

const store = createStore({
  state: {
    token: null,
    user: null,

   
    parcels:[],
    messages: [],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    removeToken(state) {
      state.token = null;
    },
    removeUser(state) {
      state.user = null;
    },
    
  },
  actions: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },

  
    async LoadClients(context) {
      const url = `https://api.roberms.com/garbage/get/clients`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const clients = [];
      for (const key in responseData) {
        const client = {
          id: key,
          client_id: responseData[key].id,
          name: responseData[key].client_name,
          phone: responseData[key].phone,
          court: responseData[key].court.CourtName,
          courtId: responseData[key].courtId,
          arrears: responseData[key].arrears,
          isActive: responseData[key].isActive,
          montlyPayment: responseData[key].monthly_payment,
          reg_date: responseData[key].createdAt,
        };
        clients.push(client);
      }
      context.commit("setClients", clients);
    },
  

   
    async LoadPayments(context) {
      const url = `https://api.roberms.com/garbage/get/payments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const payments = [];

      for (const key in responseData) {
        const payment = {
          id: key,
          client_id: responseData[key].client.id,
          name: responseData[key].client.client_name,
          court_id: responseData[key].client.courtId,
          court_name: responseData[key].client.CourtName,
          amount: responseData[key].amount,
          date: responseData[key].payment_date,
          type: responseData[key].payment_type,
          reference: responseData[key].payment_reference,
        };
        payments.push(payment);
      }
      context.commit("setPayments", payments);
    },
    async LoadMessages(context) {
      const url = `https://db.solartrax.pesa.solutions/api/doc/bootNotification`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const messages = [];
      for (const key in responseData) {
        const message = {
          id: key,
          serial_id:  responseData[key].id,
          chargePointVendor: responseData[key].chargePointVendor,
          chargePointModel: responseData[key].chargePointModel,
           chargePointSerialNumber:  responseData[key].chargePointSerialNumber,
          firmwareVersion: responseData[key].firmwareVersion,
          iccid: responseData[key].iccid,

            imsi: responseData[key].imsi,
           meterSerialNumber:  responseData[key].meterSerialNumber,
          meterType: responseData[key].meterType,
          createdAt: responseData[key].createdAt,
          

          sent_date: responseData[key].sent_date,
        };
        messages.push(message);
      }
      context.commit("setMessages", messages);
    },
    async LoadMpesapayments(context) {
      const url = `https://api.roberms.com/garbage/get/mpesapayments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const MpesaPayments = [];

      for (const key in responseData) {
        const payment = {
          id: key,

          name: responseData[key].name,
          phone: responseData[key].phone_number,
          amount: responseData[key].amount,
          payment_date: responseData[key].payment_date,
          account_number: responseData[key].account_number,
          reference: responseData[key].payment_reference,
          processed: responseData[key].processed,
        };
        MpesaPayments.push(payment);
      }
      context.commit("setMpesapayments", MpesaPayments);
    },
  },
  getters: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },

    clients: (state) => state.clients,
    messages: (state) => state.messages,
    revenues: (state) => state.revenues,
  
    messagesGetter: (state) => state.messages,
    unAllocatedMpesaPayments: (state) => () =>
      state.MpesaPayments.filter((pay) => pay.processed == 3),

    // clientName: (state) => (client)=> state.clients.filter(pay=pay.client_id=client)
  },

  //
});
export default store;
